import { motion } from 'framer-motion';
import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';

import { Confetti } from '../Confetti/Confetti';
import { BgVideo } from '../BgVideo/BgVideo';

import styles from './Winners.module.css';

import hum from '../../assets/images/hum.webp';

export const Winners = ({ winnerMessages }) => {
  const errorHandler = (e, channel) => {
    e.target.src = iconsSources[channel] || hum;
  };

  const winnerWord = winnerMessages?.length > 1 ? 'ПОБЕДИТЕЛИ!' : 'ПОБЕДИТЕЛЬ!';
  const letters = winnerWord.split('').reverse();

  const initDelay = 0.6;

  const delays = [0.4, 0, 0.8];

  const winners = winnerMessages?.slice(0, 3) || [];

  return (
    <div className={styles.wrapper}>
      <div className={styles.firstLine} dir="rtl">
        {letters.map((l, idx, arr) => {
          let initialIdx = 4;
          let oneLetterWidth = 7;
          // let initialX = `${(idx - initialIdx) * oneLetterWidth * -1}rem`;
          let initialX = `${(idx - initialIdx) * oneLetterWidth}rem`;

          return (
            <motion.div
              style={{ position: 'relative', zIndex: idx * -1 }}
              key={idx}
              initial={{
                scale: 0,
                x: initialX,
              }}
              animate={{
                scale: 1,
                x: 0,
              }}
              transition={{
                duration: 0.5,
                delay: idx * 0.05 + initDelay,
              }}
            >
              {l}
            </motion.div>
          );
        })}
      </div>

      {winners && (
        <div className={styles.winnersWrapper}>
          {winners.map((win, i) => {
            const { message } = win;
            return (
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: [0, 1.2, 1] }}
                transition={{
                  scale: {
                    duration: 1,
                    delay: delays[i],
                    times: [0, 0.7, 1],
                    ease: ['easeIn', 'easeOut'],
                  },
                }}
                className={styles.avatarBlock}
                key={message?.author + message.id}
              >
                <div className={styles.avatar}>
                  <div
                    className={styles.avatarBg}
                    style={{
                      background: `url(${
                        iconsSources[message?.channel]
                      }) center/cover no-repeat `,
                    }}
                  />
                  <img
                    src={
                      (message?.image !== '1' && message?.image) ||
                      iconsSources[message?.channel]
                    }
                    alt=""
                    onError={(e) => errorHandler(e, message?.channel)}
                  />
                </div>

                <div
                  className={styles.author}
                  style={{
                    maxWidth: winners?.length === 1 ? '120rem' : '45rem',
                    width: winners?.length === 1 ? 'auto' : '40rem',
                  }}
                >
                  {message.author || hideNumber(message?.senderNumber)}
                </div>
              </motion.div>
            );
          })}
        </div>
      )}

      <Confetti startDelay={winners?.length * 500 || 2600} />

      <BgVideo />
    </div>
  );
};
